import React from 'react'
import PropTypes from 'prop-types'
import AloCarousel from '../aloCarousel/AloCarousel'
import AccessedItemTile from './AccessedItemTile'
import camelize from 'camelize'

class AccessedItemsCarousel extends React.Component {
  render () {
    let itemCards = this.props.items.map((item, idx) => {
      item = camelize(item)
      return {
        ratioIdx: item.type === 'playlist' ? 1 : 0,
        element: <AccessedItemTile key={idx} item={item} />
      }
    })

    return (
      <AloCarousel
        numberPerItemOnPage={[2, 1]}
        leftPadding={100}
        sizeRatioOfItems={[16 / 9, 1]}
        extraItemHeight={100}
        margin={50}
        items={itemCards}
      />
    )
  }
}

AccessedItemsCarousel.propTypes = {
  items: PropTypes.array
}

export default AccessedItemsCarousel
